// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    appVersion: 'v723demo1',
    USERDATA_KEY: 'authf649fc9a5f55',
    isMockEnabled: true,
    serverUrl: 'https://api.wiselife.org.au',
    apiUrl: 'https://api.wiselife.org.au/api',
    baseUrl: 'https://api.wiselife.org.au/',
    stripeKey: 'pk_test_51KgIC4FEAZ34nr6vB8INfSlnHjrcGMRD1Pi0vL9VStyiKTz8os2Gwkq7xumjxuZc4nkH6wTxoBoK8fJqXREagasO00bZw0bB8y'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
